import { AxiosResponse } from 'axios';
import {
  SET_YURTZEITENS_N,
  SET_YURTZEITEN_N,
  SET_YURTZEITEN_N_STATS,
  SET_ERRORMSG,
} from '@/store/mutation_types';
import {
  APPROVE_YURTZEITEN_N,
  CLEAR_YURTZEITEN_N_ISLOADING,
  DELETE_YURTZEITEN_N,
  EDIT_YURTZEITEN_N,
  GET_YURTZEITEN_N,
  GET_YURTZEITEN_N_STATS,
  GET_YURTZEITENS_N,
  IMPORT_YURTZEITENS_N,
  MARK_VIEWED_YURTZEITEN_N,
  REGISTER_YURTZEITEN_N,
  REJECT_YURTZEITEN_N,
  TOGGLE_YURTZEITEN_N_IS_ACTIVE,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import Yurtzeiten_N from '@/services/yurtzeiten_N';
import { Module } from 'vuex';
import {
  GetYurtzeiten_N,
  GetYurtzeitenStats_N,
  ImportYurtzeitens_N,
} from '@/dtos/yurtzeiten_N.dto';

const yurtzeiten_N: Module<any, {}> = {
  state: {
    yurtzeiten_N: {
      data: null,
      isLoading: false,
    },
    yurtzeitens_N: {
      data: null,
      isLoading: false,
    },
    // Server-side counts per status, kept beside the list rather than derived
    // from it — the list is paged in the UI, the counts describe the whole queue.
    yurtzeitenStats_N: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    yurtzeiten_N: (state: { yurtzeiten_N: any }) => state.yurtzeiten_N,
    yurtzeitens_N: (state: { yurtzeitens_N: any }) => state.yurtzeitens_N,
    yurtzeitenStats_N: (state: { yurtzeitenStats_N: any }) => state.yurtzeitenStats_N,
  },
  mutations: {
    [SET_YURTZEITEN_N]: (
      state: { yurtzeiten_N: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.yurtzeiten_N.data = payload.data) : null;
      state.yurtzeiten_N.isLoading = payload.isLoading;
    },
    [SET_YURTZEITENS_N]: (
      state: { yurtzeitens_N: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.yurtzeitens_N.data = payload.data) : null;
      state.yurtzeitens_N.isLoading = payload.isLoading;
    },
    [SET_YURTZEITEN_N_STATS]: (
      state: { yurtzeitenStats_N: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.yurtzeitenStats_N.data = payload.data) : null;
      state.yurtzeitenStats_N.isLoading = payload.isLoading;
    },
  },
  actions: {
    [REGISTER_YURTZEITEN_N]: async ({ commit }: any, payload: FormData) => {
      commit(SET_YURTZEITEN_N, { data: null, isLoading: true });

      const result: AxiosResponse = await Yurtzeiten_N.registerYurtzeiten_N(payload);

      if (result) {
        if (result.data.status) {
          commit(SET_YURTZEITEN_N, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_YURTZEITEN_N, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_YURTZEITEN_N, { isLoading: false });
        return false;
      }
    },
    // Answers with the backend's row-by-row report, or null when the request
    // failed outright. The list's own loading state is left alone: the Import
    // modal shows its own progress, and refreshes the list when it is done.
    [IMPORT_YURTZEITENS_N]: async ({ commit }: any, payload: ImportYurtzeitens_N) => {
      const result: AxiosResponse = await Yurtzeiten_N.importYurtzeitens_N(payload);

      if (result) {
        if (result.data.status) return result.data.data;
        commit(SET_ERRORMSG, result.data.msg);
      }
      return null;
    },
    [GET_YURTZEITENS_N]: async ({ commit }: any, payload: any) => {
      commit(SET_YURTZEITENS_N, { data: null, isLoading: true });

      const result: AxiosResponse = await Yurtzeiten_N.getYurtzeitens_N(
        payload as GetYurtzeiten_N
      );

      if (result) {
        if (result.data.status) {
          commit(SET_YURTZEITENS_N, { data: result.data.data, isLoading: false });
          return result.data.data;
        }
        commit(SET_YURTZEITENS_N, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_YURTZEITENS_N, { isLoading: false });
        return false;
      }
    },
    /**
     * Counts for the submission tabs. The commit deliberately carries no data
     * while the request is open, so the bubbles hold their last numbers instead
     * of blanking out on every refresh.
     */
    [GET_YURTZEITEN_N_STATS]: async ({ commit }: any, payload: any) => {
      commit(SET_YURTZEITEN_N_STATS, { data: null, isLoading: true });

      const result: AxiosResponse = await Yurtzeiten_N.getYurtzeitenStats_N(
        payload as GetYurtzeitenStats_N
      );

      if (result) {
        if (result.data.status) {
          commit(SET_YURTZEITEN_N_STATS, {
            data: result.data.data,
            isLoading: false,
          });
          return result.data.data;
        }
        commit(SET_YURTZEITEN_N_STATS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_YURTZEITEN_N_STATS, { isLoading: false });
        return false;
      }
    },
    [GET_YURTZEITEN_N]: async ({ commit }: any, payload: any) => {
      commit(SET_YURTZEITEN_N, { data: null, isLoading: true });

      const result: AxiosResponse = await Yurtzeiten_N.getYurtzeitens_N(
        payload as GetYurtzeiten_N
      );

      if (result) {
        if (result.data.status) {
          commit(SET_YURTZEITEN_N, {
            data: result.data.data?.[0] ?? null,
            isLoading: false,
          });
          return result.data.data?.[0];
        }
        commit(SET_YURTZEITEN_N, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_YURTZEITEN_N, { isLoading: false });
        return false;
      }
    },
    [EDIT_YURTZEITEN_N]: async ({ commit, state }: any, payload: FormData) => {
      commit(SET_YURTZEITEN_N, { data: null, isLoading: true });

      const result: AxiosResponse = await Yurtzeiten_N.editYurtzeiten_N(payload);

      if (result) {
        if (result.data.status) {
          // Keep the loaded list in step with the saved record so an inline edit
          // (e.g. the recurring toggle) doesn't need a full refetch.
          if (state.yurtzeitens_N?.data && Array.isArray(state.yurtzeitens_N.data)) {
            const index = state.yurtzeitens_N.data.findIndex(
              (e: any) => e.id == result.data.data.id
            );
            if (index !== -1) {
              state.yurtzeitens_N.data[index] = {
                ...state.yurtzeitens_N.data[index],
                ...result.data.data,
              };
            }
          }
          commit(SET_YURTZEITEN_N, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_YURTZEITEN_N, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_YURTZEITEN_N, { isLoading: false });
        return false;
      }
    },
    [TOGGLE_YURTZEITEN_N_IS_ACTIVE]: async ({ commit, state }: any, payload: { id: string }) => {
      commit(SET_YURTZEITEN_N, { data: { id: payload.id }, isLoading: true });

      const result: AxiosResponse = await Yurtzeiten_N.toggleYurtzeiten_NIsActive(payload);

      if (result) {
        if (result.data.status) {
          let index: number | null = null;
          if (state.yurtzeitens_N?.data && Array.isArray(state.yurtzeitens_N.data)) {
            state.yurtzeitens_N.data.forEach((e: any, i: number) => {
              if (e.id == result.data.data.id) {
                index = i;
              }
            });
            if (index != null) {
              state.yurtzeitens_N.data[index].isActive = result.data.data.isActive;
            }
          }
          commit(SET_YURTZEITEN_N, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_YURTZEITEN_N, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_YURTZEITEN_N, { isLoading: false });
        return false;
      }
    },
    [APPROVE_YURTZEITEN_N]: async ({ commit, state }: any, payload: string) => {
      commit(SET_YURTZEITEN_N, { data: null, isLoading: true });

      const result: AxiosResponse = await Yurtzeiten_N.approveYurtzeiten_N(payload);

      if (result) {
        if (result.data.status) {
          let index: number | null = null;
          if (state.yurtzeitens_N?.data && Array.isArray(state.yurtzeitens_N.data)) {
            state.yurtzeitens_N.data.forEach((e: any, i: number) => {
              if (e.id == result.data.data.id) {
                index = i;
              }
            });
            if (index != null) {
              state.yurtzeitens_N.data[index].status = result.data.data.status;
              state.yurtzeitens_N.data[index].approvedDate = result.data.data.approvedDate;
              state.yurtzeitens_N.data[index].rejectedDate = result.data.data.rejectedDate;
            }
          }
          commit(SET_YURTZEITEN_N, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_YURTZEITEN_N, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_YURTZEITEN_N, { isLoading: false });
        return false;
      }
    },
    [REJECT_YURTZEITEN_N]: async ({ commit, state }: any, payload: string) => {
      commit(SET_YURTZEITEN_N, { data: null, isLoading: true });

      const result: AxiosResponse = await Yurtzeiten_N.rejectYurtzeiten_N(payload);

      if (result) {
        if (result.data.status) {
          let index: number | null = null;
          if (state.yurtzeitens_N?.data && Array.isArray(state.yurtzeitens_N.data)) {
            state.yurtzeitens_N.data.forEach((e: any, i: number) => {
              if (e.id == result.data.data.id) {
                index = i;
              }
            });
            if (index != null) {
              state.yurtzeitens_N.data[index].status = result.data.data.status;
              state.yurtzeitens_N.data[index].approvedDate = result.data.data.approvedDate;
              state.yurtzeitens_N.data[index].rejectedDate = result.data.data.rejectedDate;
            }
          }
          commit(SET_YURTZEITEN_N, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_YURTZEITEN_N, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_YURTZEITEN_N, { isLoading: false });
        return false;
      }
    },
    /**
     * Marks a submission as read. Unlike its neighbours this touches neither
     * `isLoading` flag: it fires in the background every time a row is opened,
     * and `yurtzeiten_N.isLoading` is what the Add / Edit / Delete modals spin
     * on — a row click has no business moving those. Only the matching list
     * entry is patched, so the NEW badge flips without a refetch.
     */
    [MARK_VIEWED_YURTZEITEN_N]: async ({ state }: any, payload: string) => {
      const result: AxiosResponse = await Yurtzeiten_N.markViewedYurtzeiten_N(payload);

      if (result?.data?.status) {
        if (state.yurtzeitens_N?.data && Array.isArray(state.yurtzeitens_N.data)) {
          const index = state.yurtzeitens_N.data.findIndex(
            (e: any) => e.id == result.data.data.id
          );
          if (index !== -1) {
            state.yurtzeitens_N.data[index].isViewed = result.data.data.isViewed;
          }
        }
        return true;
      }
      return false;
    },
    [DELETE_YURTZEITEN_N]: async ({ commit }: any, payload: string) => {
      commit(SET_YURTZEITEN_N, { data: null, isLoading: true });

      const result: AxiosResponse = await Yurtzeiten_N.deleteYurtzeiten_N(payload);

      if (result) {
        if (result.data.status) {
          commit(SET_YURTZEITEN_N, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_YURTZEITEN_N, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_YURTZEITEN_N, { isLoading: false });
        return false;
      }
    },
    [CLEAR_YURTZEITEN_N_ISLOADING]: ({ commit }) => {
      commit(SET_YURTZEITEN_N, { isLoading: false });
      commit(SET_YURTZEITENS_N, { isLoading: false });
      commit(SET_YURTZEITEN_N_STATS, { isLoading: false });
    },
  },
};

export default yurtzeiten_N;
